import type { Components, CssVarsTheme } from '@mui/material/styles';

export const MuiSlider: Components<CssVarsTheme>['MuiSlider'] = {
  defaultProps: {
    size: 'small'
  },
  styleOverrides: {
    root: ({ theme }) => ({
      '&.Mui-disabled': {
        color: theme.vars.palette.action.disabled
      },
      '& .MuiSlider-thumb': {
        transform: 'translate(-50%, -50%)'
      }
    }),
    rail: {
      opacity: 0.32
    },
    markLabel: ({ theme }) => ({
      fontSize: 13,
      color: theme.vars.palette.text.disabled
    }),
    valueLabel: ({ theme }) => ({
      borderRadius: 8,
      backgroundColor: theme.vars.palette.grey[800]
    })
  }
};
